import  { h } from 'preact';
import Input from "@src/components/input";
import {useCallback} from "preact/hooks";
import {forwardRef} from "preact/compat";


const SendCodeInput = forwardRef(({ onChange, ...props },ref) => {
  const valueChange = useCallback(e => {
    if (!e.target.value || /^\d+$/.test(e.target.value)) {
      onChange(e);
    }
  }, []);
  return <Input ref={ref} onChange={valueChange} type={'text'}  {...props}  />;
});

export default SendCodeInput;
